import { TEventSpecificData } from '@/core/constants/event_types/base_mable_event';
import { WtagFunction } from '@/core/constants/helpers_types/types';

export type EventPayload = TEventSpecificData;

export abstract class AEventTrigger {
  wtagFunctions: WtagFunction[];
  wtagFunction: WtagFunction;
  isRegistered = false;
  constructor(wtagFunctions: WtagFunction | WtagFunction[]) {
    if (typeof wtagFunctions === 'function' || !Array.isArray(wtagFunctions)) {
      wtagFunctions = [wtagFunctions];
    }

    /*The wtag function is the interface used to interact with the core modules of the 
    bundle. Call the function when a event is to be sent.
    */
    if (wtagFunctions.length === 0 || !wtagFunctions[0]) {
      throw new Error('Wtag functions are required');
    }
    this.wtagFunctions = wtagFunctions;
    this.wtagFunction = wtagFunctions[0];
  }

  abstract registerEvent(): void;
  // abstract handleEventTriggered(): handleEventTriggeredType;
}
